import instance from '@/api/instance';

////////// CP

export let SpSiteCpRead = function (data) {
    return instance.post('/spsite/cp/read', data)
}

export let SpSiteCpUpdate = function (data) {
    return instance.post('/spsite/cp/update', data)
}

export let SpSiteCpCreate = function (data) {
    return instance.post('/spsite/cp/create', data)
}

export let SpSiteCpRefreshCache = function (data) {
    return instance.post('/spsite/cp/refresh/cache', data)
}

////////// SP

export let SpSiteSpRead = function (data) {
    return instance.post('/spsite/sp/read', data)
}

export let SpSiteSpUpdate = function (data) {
    return instance.post('/spsite/sp/update', data)
}

export let SpSiteSpCreate = function (data) {
    return instance.post('/spsite/sp/create', data)
}

export let SpSiteSpRefreshCache = function (data) {
    return instance.post('/spsite/sp/refresh/cache', data)
}

////////// SP APP
export let SpSiteSpAppRead = function (data) {
    return instance.post('/spsite/sp/app/read', data)
}

export let SpSiteSpAppCreate = function (data) {
    return instance.post('/spsite/sp/app/create', data)
}

export let SpSiteSpAppUpdate = function (data) {
    return instance.post('/spsite/sp/app/update', data)
}

////////// SP CP APP
export let SpSiteSpCpAppRead = function (data) {
    return instance.post('/spsite/sp/cp/app/read', data)
}

export let SpSiteSpCpAppReject = function (data) {
    return instance.post('/spsite/sp/cp/app/reject', data)
}

export let SpSiteSpCpAppResolve = function (data) {
    return instance.post('/spsite/sp/cp/app/resolve', data)
}

export let SpSiteSpCpAppCreate = function (data) {
    return instance.post('/spsite/sp/cp/app/create', data)
}

////////// SP TPL
export let SpSiteTplRead = function (data) {
    return instance.post('/spsite/tpl/read', data)
}

export let SpSiteTplReject = function (data) {
    return instance.post('/spsite/tpl/reject', data)
}

export let SpSiteTplResolve = function (data) {
    return instance.post('/spsite/tpl/resolve', data)
}

////////// CP PACK
export let SpSiteCpPackRead = function (data) {
    return instance.post("/spsite/cp/pack/read", data)
}

export let SpSiteCpPackCreate = function (data) {
    return instance.post("/spsite/cp/pack/create", data)
}

////////// TRANSACTION
export let SpSiteTransactionDetailRead = function (data) {
    return instance.post("/spsite/trx/read", data)
}

export let SpSiteTransactionDetailExport = function (data) {
    return instance.post("/spsite/trx/export", data)
}

export let SpSiteTransactionSummaryRead = function (data) {
    return instance.post("/spsite/trx/read/summary", data)
}

export let SpSiteTransactionReportRead = function (data) {
    return instance.post("/spsite/trx/read/report", data)
}

////////// TRANSACTION TEST
export let SpSiteTransactionTestCreate = function (data) {
    return instance.post("/spsite/trxt/create", data)
}

export let SpSiteTransactionTestUpdate = function (data) {
    return instance.post("/spsite/trxt/update", data)
}

export let SpSiteTransactionTestRead = function (data) {
    return instance.post("/spsite/trxt/read", data)
}

export let SpSiteTransactionTestDelete = function (data) {
    return instance.post("/spsite/trxt/delete", data)
}

export let SpSiteTransactionTestSend = function (data) {
    return instance.post("/spsite/trxt/send", data)
}

////////// SMPP NODE
export let SpSiteSmppNodeRead = function (data) {
    return instance.post("/spsite/smpp/node/read", data)
}

export let SpSiteSmppNodeCreate = function (data) {
    return instance.post("/spsite/smpp/node/create", data)
}

export let SpSiteSmppNodeUpdate = function (data) {
    return instance.post("/spsite/smpp/node/update", data)
}

////////// message
export let SpSiteMessageRead = function (data) {
    return instance.post("/spsite/message/read", data)
}

export let SpSiteMessageExport = function (data) {
    return instance.post("/spsite/message/export", data)
}
